// src/components/personal/sections/ClientsSection/utils/error-utils.ts
import { useTranslation } from 'react-i18next';
import { APIError } from '../types/types';
import { ERROR_CODES, ERROR_TRANSLATION_KEYS, ERROR_MESSAGES } from '../error/error-constants';

// Получить сообщение об ошибке с поддержкой i18n
export const getErrorMessage = (error: APIError): string => {
  const { t } = useTranslation();
  
  // Если есть ключ перевода для данного кода ошибки, используем его
  if (error.code && error.code in ERROR_TRANSLATION_KEYS) {
    const key = ERROR_TRANSLATION_KEYS[error.code as keyof typeof ERROR_TRANSLATION_KEYS];
    return t(key);
  }
  
  // Иначе используем сообщение из ошибки или дефолтное сообщение
  return error.message || 
         (error.code ? ERROR_MESSAGES[error.code as keyof typeof ERROR_MESSAGES] : undefined) || 
         t('errors.unknown');
};

// Вариант для использования вне компонентов React
export const getErrorMessageStatic = (error: APIError, t: (key: string) => string): string => {
  // Если есть ключ перевода для данного кода ошибки, используем его
  if (error.code && error.code in ERROR_TRANSLATION_KEYS) {
    const key = ERROR_TRANSLATION_KEYS[error.code as keyof typeof ERROR_TRANSLATION_KEYS];
    return t(key);
  }
  
  // Иначе используем сообщение из ошибки или дефолтное сообщение
  return error.message || 
         (error.code ? ERROR_MESSAGES[error.code as keyof typeof ERROR_MESSAGES] : undefined) || 
         t('errors.unknown');
};

export const shouldRetry = (error: APIError): boolean => {
  return error.code === ERROR_CODES.NETWORK_ERROR || 
         error.code === ERROR_CODES.SERVER_ERROR;
};